export default "__VITE_ASSET__CsnWuw1g__"